import { render, staticRenderFns } from "./ReservedArticlesModal.vue?vue&type=template&id=1573f9bc"
import script from "./ReservedArticlesModal.ts?vue&type=script&lang=ts&external"
export * from "./ReservedArticlesModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports